export const userDeviceAccessRoles = {
  DEVICE_ADMIN: 'DEVICE_ADMIN',
  GUEST: 'GUEST',
}
